import moment from 'moment';
import { useFetchProfessionalDsoAttestation } from '../hooks/useFetchProfessionalDsoAttestation';
import { RemoteConfigUtils } from '../../../../utils/RemoteConfigUtils';
import { formatDsoName } from '../../../../utils/String';

export const ProfessionalDsoAttestationLineInfo = ({ userId, dsoCode }) => {
  const { data } = useFetchProfessionalDsoAttestation(userId, dsoCode);
  const expiredAt = data?.consented_requirements?.[0]?.expired_at;
  const expiredAtFormatted = expiredAt ? moment(expiredAt).format('ddd, MMMM Do, YYYY') : '-';

  return (
    <div
      style={{
        width: '100%',
        borderBottom: '1px solid #efefef',
        padding: '5px 10px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <p className="card-text" style={{ fontWeight: '600' }}>
        {formatDsoName(dsoCode)} Attestation:
      </p>
      <p className="card-text">{expiredAtFormatted}</p>
    </div>
  );
};

export const ProfessionalDsoAttestationList = ({ userId }) => {
  const dsoCodes = Object.keys(RemoteConfigUtils.getDsoNameConsents());

  if (dsoCodes.length === 0) {
    return null;
  }

  return dsoCodes.map((code) => (
    <ProfessionalDsoAttestationLineInfo key={code} userId={userId} dsoCode={code} />
  ));
};
